// extracted by mini-css-extract-plugin
export default {"root":"NoMatch-root","card":"NoMatch-card","image":"NoMatch-image","button":"NoMatch-button"};